export const ListItem = 22

export const ExtensionListItem = 62

export const ActivityBarItem = 48

export const MinimumSliderSize = 20

export const CompletionItem = 20
